// import { createApp } from 'vue'
// import VueQuillEditor from 'vue-quill-editor'
// import 'quill/dist/quill.core.css' // import styles
// import 'quill/dist/quill.snow.css' // for snow theme
// import 'quill/dist/quill.bubble.css' // for bubble theme
// import App from './App.vue'

// import qs from 'qs'
// import router from './router'
// import store from './store'
// import installElementPlus from './plugins/element'
// // import pjsua from 'pjsip-js';
// import cmDirectives from 'cm-directives'



// import 'element-plus/lib/theme-chalk/index.css';

// import './assets/css/icon.css'
// import vueMiniPlayer from 'vue-mini-player'
// import 'vue-mini-player/lib/vue-mini-player.css'
// import Plugin from 'v-fit-columns';


// const app = createApp(App).use(router).use(store).use(qs).use(VueQuillEditor).use(vueMiniPlayer).use(
// 	Plugin).use(cmDirectives)
// installElementPlus(app),
// 	app.mount('#app')


import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import installElementPlus from './plugins/element'

// 第三方库直接导入
import VueQuillEditor from 'vue-quill-editor'
import vueMiniPlayer from 'vue-mini-player'
import VFitColumns from 'v-fit-columns'
import cmDirectives from 'cm-directives'


// 样式文件
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'element-plus/lib/theme-chalk/index.css'
import 'vue-mini-player/lib/vue-mini-player.css'
import './assets/css/icon.css'

const app = createApp(App)

// 安装Element Plus插件
installElementPlus(app)

// 安装其他第三方插件
app.use(VueQuillEditor)
	.use(vueMiniPlayer)
	.use(VFitColumns)
	.use(cmDirectives)

// 安装路由和状态管理
app.use(router)
	.use(store)

app.mount('#app')